import ReactDOM from 'react-dom/client';
import CloverApp from './CloverApp';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<CloverApp />);
